import React,{useState,useEffect} from 'react'
import {color_pallete} from '../Common/static.js'
import {Gap} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { changeColorPalletes } from '../Store/allreducer.js';
const Palli = ({colors,setCurrentColorPallete, isHighlighted, setIsHighlighted}) => {
  //console.log('colors',colors)
  //console.log('colorsds',setCurrentColorPallete);
  const handleHighlight = () => {
    setIsHighlighted(true);
  };
    return (
    <div  className={'hover:cursor-pointer  '+(isHighlighted?' border-4 border-violet-500':'')}
    style={{display: 'flex', flexDirection: 'row',marginTop:'10px', width:'fit-content',marginRight:'13px'}}
    onClick={(e) => {setCurrentColorPallete(colors); handleHighlight();}}>
        <div style={{backgroundColor: `${colors.first_color}`,height:'17px',width:'17px'}}>
            
        </div>
        <div style={{backgroundColor: `${colors.second_color}`,height:'17px',width:'17px'}}>
            
        </div>
        <div style={{backgroundColor: `${colors.third_color}`,height:'17px',width:'17px'}}>

        </div>
    </div>
    )
}

const Pallette = () => {
    const palleteNum = Array.from({ length: 36 }, (v, i) => i + 1);
    const [currentColorPallete, setCurrentColorPallete] = useState({first_color: '#D6DBB2', second_color: '#3C3C3C', third_color: '#e88411'});
    const [highlightedPalette, setHighlightedPalette] = useState(9);
    
    const dispatch = useDispatch();
    
    const { currentColorPalletes} = useSelector(
      (state) => state.counter,
    );

    useEffect(() => {
      setCurrentColorPallete(currentColorPalletes);
      const index = color_pallete.findIndex(item => item.first_color === currentColorPalletes.first_color);
      setHighlightedPalette(index);
    },[currentColorPalletes]);
    
//console.log('currentColorPallete',currentColorPallete)

// Dispatch the action only when the currentColorPalletes state changes
useEffect(() => {
  
  dispatch(changeColorPalletes({currentColorPalletes: currentColorPallete}));
}, [ currentColorPallete,dispatch]);

  return (
    <div style={{display: 'flex', flexWrap:'wrap', height:'auto',width:'90%'}} >

      {color_pallete.map((data,idx) =>
       <Palli key={idx} 
       colors={data}
        setCurrentColorPallete={setCurrentColorPallete}
        isHighlighted={highlightedPalette === idx}
          setIsHighlighted={() => setHighlightedPalette(idx)} />
       )} 
      
    </div>
  )
}

export default Pallette;